import { Card } from 'components/Card';
import { SkeletonAction } from 'components/SkeletonAction';
import { SkeletonText } from 'components/SkeletonText';
import { Stack } from 'components/Stack';

export function SkeletonContent() {
  return (
    <Stack vertical>
      <SkeletonAction />
      <Stack vertical>
        <Card sectioned>
          <SkeletonText />
        </Card>
        <Card sectioned>
          <SkeletonText lines={2} />
        </Card>
      </Stack>
    </Stack>
  );
}
